import {qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Component} from '@packages/systems/wfdl';

import {
  ADD_TO_CART_OPTION_CONTEXT_TYPE_ID,
  ADD_TO_CART_OPTION_CONTEXT_ID,
} from './identifiers';

import type {
  BindingContextDef,
  BindingContextTypeDef,
  BindablePropertiesDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';

export const addToCartType: BindingContextTypeDef = {
  entity: 'Entity',
  id: ADD_TO_CART_OPTION_CONTEXT_TYPE_ID,
  label: 'Product Options',
  pluralLabel: 'Product Options',
  singularLabel: 'Product Option',
  iconName: 'product',
};

export function addToCartBindingContext<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextDef<RootTRef, EntityTRef, ListTRef> {
  return {
    variant: 'List',
    id: ADD_TO_CART_OPTION_CONTEXT_ID,
    label: 'Product Options',
    type: typeReferenceBuilder.listOf({
      entity: 'Entity',
      id: ADD_TO_CART_OPTION_CONTEXT_TYPE_ID,
    }),
    matchElement: {
      elementType: qualify(
        Plugins.name('Commerce'),
        Component.name('CommerceAddToCartOption')
      ),
    },
  };
}

export function addToCartBindableProperties<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindablePropertiesDef<EntityTRef, ListTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'Entity',
      id: ADD_TO_CART_OPTION_CONTEXT_TYPE_ID,
    }),
    bindableProperties: [
      {
        id: 'commerce-add-to-cart-option-name',
        label: 'Name',
        type: 'PlainText',
        path: [{id: '', slug: 'name', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {
          strategy: 'client',
        },
      },
    ],
  };
}
